import { environment } from './../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PromocoesService {
  BASEURL: string;
  httpHeaders: HttpHeaders;

  constructor(private http: HttpClient) {
    this.BASEURL = environment.apiUrl;

    this.httpHeaders = new HttpHeaders({
      Authorization: localStorage.getItem('tokenMappe'),
    });
  }

  listaPromocoes(id: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/deals/brands/${id}`, {
      headers: this.httpHeaders,
    });
  }

  excluirPromocao(id: string): Observable<any> {
    return this.http.delete(`${this.BASEURL}/deals/${id}`, {
      headers: this.httpHeaders,
    });
  }

  uploadImages(image: string): Observable<any> {
    return this.http.post(`${this.BASEURL}/images`, {
      image
    }, {
      headers: this.httpHeaders,
    });
  }

  listaMarcas(): Observable<any> {
    return this.http.get(`${this.BASEURL}/brands`, {
      headers: this.httpHeaders,
    });
  }

  listaProdutosPorMarca(id: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/items/brands/${id}`, {
      headers: this.httpHeaders,
    });
  }

  obterPromocao(id: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/deals/${id}`, {
      headers: this.httpHeaders,
    });
  }

  salvaPromocao(body: any): Observable<any> {
    return this.http.post(`${this.BASEURL}/deals`, body, {
      headers: this.httpHeaders,
    });
  }

  editarPromocao(id: string, body: any): Observable<any> {
    return this.http.put(`${this.BASEURL}/deals/${id}`, body, {
      headers: this.httpHeaders,
    });
  }

  obterMoedas(): Observable<any> {
    return this.http.get(`${this.BASEURL}/currencies`, {
      headers: this.httpHeaders,
    });
  }
}
